import VerifyToken from './VerifyToken';

export default VerifyToken;
